import { FC } from 'react';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

export const PageLoader: FC = () => {
  const { pageLoading } = useSiteConfig();

  return pageLoading ? <div className={styles.loader} /> : null;
};
